<template>
    <a-modal :title="$t('platformCollection.investor_details')" :width="1650" :visible="visible" :footer="null" @cancel="handleCancel">
        <a-spin :spinning="loading">
            <div class="detail-container" v-if="detailData">
                <!-- Registration info -->
                <div class="section">
                    <div class="section-title">{{ $t('platformCollection.registration_info') }}</div>
                    <div class="section-content">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.investor_id') }}:</span>
                                <span class="value">{{ detailData.id || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.account') }}:</span>
                                <span class="value">{{ detailData.mobile || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.status') }}:</span>
                                <span class="value">{{ detailData.status === 1 ? $t('platformCollection.normal') : $t('platformCollection.disabled') }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.register_time') }}:</span>
                                <span class="value">{{ detailData.registerTime || '-' }}</span>
                            </a-col>
                        </a-row>
                    </div>
                </div>

                <!-- Account opening info -->
                <div class="section">
                    <div class="section-title">{{ $t('platformCollection.account_info') }}</div>
                    <div class="section-content">
                        <a-row :gutter="[16, 16]">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.institution_name') }}:</span>
                                <span class="value">{{ detailData.companyName || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.tax_id') }}:</span>
                                <span class="value">{{ detailData.taxId || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.registered_address') }}:</span>
                                <span class="value">{{ detailData.enterpriseAddress || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.registered_capital') }}:</span>
                                <span class="value">{{ (detailData.registeredCapital || 0) | NumberFormat }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[16, 16]" style="margin-top: 16px;">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.institution_phone') }}:</span>
                                <span class="value">{{ detailData.companyPhone || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.issue_authority') }}:</span>
                                <span class="value">{{ detailData.issueAuthority || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.institution_email') }}:</span>
                                <span class="value">{{ detailData.email || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.registration_date') }}:</span>
                                <span class="value">{{ detailData.registrationDate || '-' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[16, 16]" style="margin-top: 16px;">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.tax_status') }}:</span>
                                <span class="value">{{ detailData.taxStatus || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_gender') }}:</span>
                                <span class="value"><Dict :dict-code="DICT_CODE.SEX" :value="detailData.legalPersonGender" /></span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_birthday') }}:</span>
                                <span class="value">{{ detailData.legalPersonBirthday || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_ethnicity') }}:</span>
                                <span class="value">{{ detailData.legalPersonEthnicity || '-' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[16, 16]" style="margin-top: 16px;">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_name') }}:</span>
                                <span class="value">{{ detailData.legalPersonName || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_id_type') }}:</span>
                                <span class="value">{{ detailData.legalPersonIdType || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_id_no') }}:</span>
                                <span class="value">{{ detailData.legalPersonIdNo || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_id_issue_date') }}:</span>
                                <span class="value">{{ detailData.legalPersonIdIssueDate || '-' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[16, 16]" style="margin-top: 16px;">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_nationality') }}:</span>
                                <span class="value">{{ detailData.legalPersonNationality || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_contact_address') }}:</span>
                                <span class="value">{{ detailData.legalPersonContactAddress || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_residence_address') }}:</span>
                                <span class="value">{{ detailData.legalPersonResidenceAddress || '-' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.legal_person_id_issue_place') }}:</span>
                                <span class="value">{{ detailData.legalPersonIdIssuePlace || '-' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="[16, 16]" style="margin-top: 16px;">
                            <a-col :span="6">
                                <span class="label">{{ $t('platformCollection.company_business_license') }}:</span>
                                <span class="value">
                                    <a v-if="detailData.companyRegistrationCertificate" @click.prevent="handleDownloadLicense" style="color: #1890ff; cursor: pointer;">
                                        {{ $t('platformCollection.download_license') }}
                                    </a>
                                    <span v-else>-</span>
                                </span>
                            </a-col>
                        </a-row>

                        <!-- Legal person ID photo -->
                        <div style="margin-top: 20px;">
                            <span class="label" style="display: inline-block; margin-right: 12px; vertical-align: top;">{{ $t('platformCollection.legal_person_photo') }}:</span>
                            <div class="img-box-container" style="display: inline-flex; flex-wrap: wrap; gap: 16px;">
                                <div class="img-box" v-if="detailData.idCardFront" style="display:flex;flex-direction:column;align-items:center;">
                                    <img :src="detailData.idCardFront" style="width:160px;height:96px;object-fit:cover;border:1px solid #d9d9d9;border-radius:4px;cursor:pointer;" @click="handlePreview(detailData.idCardFront)" />
                                    <span style="font-size:12px;color:#999;margin-top:4px;">{{ $t('platformCollection.front') }}</span>
                                </div>
                                <div class="img-box" v-if="detailData.idCardBack" style="display:flex;flex-direction:column;align-items:center;">
                                    <img :src="detailData.idCardBack" style="width:160px;height:96px;object-fit:cover;border:1px solid #d9d9d9;border-radius:4px;cursor:pointer;" @click="handlePreview(detailData.idCardBack)" />
                                    <span style="font-size:12px;color:#999;margin-top:4px;">{{ $t('platformCollection.back') }}</span>
                                </div>
                                <div class="img-box" v-if="detailData.livenessVerification" style="display:flex;flex-direction:column;align-items:center;">
                                    <img :src="detailData.livenessVerification" style="width:160px;height:96px;object-fit:cover;border:1px solid #d9d9d9;border-radius:4px;cursor:pointer;" @click="handlePreview(detailData.livenessVerification)" />
                                    <span style="font-size:12px;color:#999;margin-top:4px;">{{ $t('platformCollection.liveness_verification') }}</span>
                                </div>
                                <span v-if="!detailData.idCardFront && !detailData.idCardBack && !detailData.livenessVerification">-</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Risk assessment details -->
                <div class="section">
                    <div class="section-title">{{ $t('platformCollection.risk_assessment_details') }}</div>
                    <div class="section-content">
                        <div class="risk-info">
                            <div class="risk-level">{{ $t('platformCollection.risk_preference') }}:{{ detailData.level || '-' }}</div>
                            <div class="qa-container"
                                v-if="detailData.questionAndAnswerList && detailData.questionAndAnswerList.length">
                                <div class="qa-item" v-for="(item, index) in detailData.questionAndAnswerList"
                                    :key="index">
                                    <div class="qa-question">{{ $t('platformCollection.question') }}{{ index + 1 }}:{{ getQuestion(item) }}</div>
                                    <div class="qa-answer">{{ $t('platformCollection.answer') }}:{{ getAnswer(item) }}</div>
                                </div>
                            </div>
                            <div v-else class="no-data">{{ $t('platformCollection.no_assessment_data') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </a-spin>

        <!-- Image preview modal -->
        <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </a-modal>
</template>

<script>
import { getInvestorDetail } from '@/webpublicapi/vietnamBackstage'
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'

export default {
    name: 'InvestorDetailModal',
    components: {
        Dict
    },
    data() {
        return {
            visible: false,
            loading: false,
            detailData: null,
            previewVisible: false,
            previewImage: ''
        }
    },
    methods: {
        async show(record) {
            this.visible = true
            this.loading = true
            this.detailData = null
            try {
                const res = await getInvestorDetail({ investUserId: record.id })
                if (res.success && res.respData) {
                    this.detailData = res.respData
                    this.detailData.id = record.id
                    this.detailData.name = record.name
                    this.detailData.mobile = record.mobile
                    this.detailData.status = record.status
                    this.detailData.registerTime = record.registerTime

                    // Mapping enterprise Info to top level, unified template reference
                    const cr = res.respData.companyRegistration
                    if (cr) {
                        this.detailData.companyName = cr.companyNameVi
                        this.detailData.taxId = cr.businessNumber
                        this.detailData.enterpriseAddress = cr.companyAddress
                        this.detailData.registeredCapital = cr.charterCapital
                        this.detailData.companyPhone = cr.companyPhone
                        this.detailData.issueAuthority = cr.registrationPlace
                        this.detailData.email = cr.email
                        this.detailData.registrationDate = cr.registrationDate
                        this.detailData.taxStatus = cr.taxStatus
                        this.detailData.legalPersonName = cr.legalRepresentativeName
                        this.detailData.legalPersonGender = cr.legalRepresentativeGender === 'Nam' ? 1 : cr.legalRepresentativeGender === 'Nữ' ? 0 : cr.legalRepresentativeGender
                        this.detailData.legalPersonBirthday = cr.legalRepresentativeDateOfBirth
                        this.detailData.legalPersonEthnicity = cr.legalRepresentativeEthnicity
                        this.detailData.legalPersonNationality = cr.legalRepresentativeNationality
                        this.detailData.legalPersonIdType = cr.legalRepresentativeDocumentType
                        this.detailData.legalPersonIdNo = cr.legalRepresentativeDocNumber
                        this.detailData.legalPersonIdIssueDate = cr.legalRepresentativeDateOfIssuance
                        this.detailData.legalPersonIdIssuePlace = cr.legalRepresentativePlaceOfIssuance
                        this.detailData.legalPersonContactAddress = cr.legalRepresentativeContactAddress
                        this.detailData.legalPersonResidenceAddress = cr.legalRepresentativeResidenceAddress
                    }
                } else {
                    this.$message.warning(res.respMsg || this.$t('platformCollection.get_details_failed'))
                }
            } catch (e) {
                console.error(e)
                this.$message.error(this.$t('platformCollection.system_error'))
            } finally {
                this.loading = false
            }
        },
        handleCancel() {
            this.visible = false
        },
        getQuestion(item) {
            if (!item) return ''
            const colonIndex = item.indexOf(':')
            return colonIndex === -1 ? item : item.substring(0, colonIndex)
        },
        getAnswer(item) {
            if (!item) return ''
            const colonIndex = item.indexOf(':')
            return colonIndex === -1 ? '' : item.substring(colonIndex + 1)
        },
        handlePreview(imgUrl) {
            this.previewImage = imgUrl
            this.previewVisible = true
        },
        handleDownloadLicense() {
            const url = this.detailData.companyRegistrationCertificate
            if (!url) return
            const link = document.createElement('a')
            link.href = url
            link.download = 'company_registration_certificate.pdf'
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}
</script>

<style lang="less" scoped>
.detail-container {
    .section {
        margin-bottom: 24px;

        .section-title {
            background: #e6f7ff;
            padding: 8px 16px;
            font-weight: bold;
            color: #333;
            margin-bottom: 16px;
        }

        .section-content {
            padding: 0 16px;

            .label {
                color: #333;
                font-weight: 500;
            }

            .value {
                color: #666;
            }

            .img-section {
                .img-box-container {
                    display: flex;
                    gap: 16px;
                    margin-top: 8px;

                    .img-box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        img {
                            width: 160px;
                            height: 96px;
                            object-fit: cover;
                            border: 1px solid #d9d9d9;
                            border-radius: 4px;
                            background: #f5f5f5;
                            margin-bottom: 4px;
                        }

                        span {
                            font-size: 12px;
                            color: #999;
                        }
                    }
                }
            }

            .doc-img-container {
                img {
                    max-width: 300px;
                    max-height: 200px;
                    object-fit: contain;
                    border: 1px solid #d9d9d9;
                    border-radius: 4px;
                    cursor: pointer;
                    background: #f5f5f5;
                }
            }
        }
    }

    .risk-info {
        .risk-level {
            font-weight: 500;
            margin-bottom: 12px;
            color: #333;
        }

        .qa-container {
            border: 1px solid #e8e8e8;
            border-radius: 8px;
            padding: 16px;
            background: #fafafa;

            .qa-item {
                margin-bottom: 12px;
                color: #333;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .no-data {
            color: #999;
            text-align: center;
            padding: 20px;
        }
    }
}
</style>
